__turbopack_context__.v({
  "tocContainer": "VwvDUW_tocContainer",
  "tocLink": "VwvDUW_tocLink",
  "tocLinkArrow": "VwvDUW_tocLinkArrow",
  "tocTitle": "VwvDUW_tocTitle",
});
